<template>
  <div class="editor"
       :class="{'editor_small': small}">
    <p class="editor-label">{{ label }}
      <i v-if="help"
         class="mdi mdi-help-circle-outline pointer"
         v-tooltip="help"></i>
    </p>
    <div class="editor-body"
         :class="{ 'editor-body_disabled': disabled }">


        <div class="menubar">
          <button type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('bold') }"
                  @click="editor.chain().focus().toggleBold().run()">
            <svg viewBox="0 0 24 24"
                 id="icon--bold">
              <path d="M17.194 10.962A6.271 6.271 0 0012.844.248H4.3a1.25 1.25 0 000 2.5h1.013a.25.25 0 01.25.25V21a.25.25 0 01-.25.25H4.3a1.25 1.25 0 100 2.5h9.963a6.742 6.742 0 002.93-12.786zm-4.35-8.214a3.762 3.762 0 010 7.523H8.313a.25.25 0 01-.25-.25V3a.25.25 0 01.25-.25zm1.42 18.5H8.313a.25.25 0 01-.25-.25v-7.977a.25.25 0 01.25-.25h5.951a4.239 4.239 0 010 8.477z"></path>
            </svg>
          </button>

          <button type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('italic') }"
                  @click="editor.chain().focus().toggleItalic().run()">
            <svg viewBox="0 0 24 24"
                 id="icon--italic">
              <path d="M22.5.248h-7.637a1.25 1.25 0 000 2.5h1.086a.25.25 0 01.211.384L4.78 21.017a.5.5 0 01-.422.231H1.5a1.25 1.25 0 000 2.5h7.637a1.25 1.25 0 000-2.5H8.051a.25.25 0 01-.211-.384L19.22 2.98a.5.5 0 01.422-.232H22.5a1.25 1.25 0 000-2.5z"></path>
            </svg>
          </button>

          <button type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('strike') }"
                  @click="editor.chain().focus().toggleStrike().run()">
            <svg viewBox="0 0 24 24"
                 id="icon--strike">
              <path d="M23.75 12.952A1.25 1.25 0 0022.5 11.7h-8.936a.492.492 0 01-.282-.09c-.722-.513-1.482-.981-2.218-1.432-2.8-1.715-4.5-2.9-4.5-4.863 0-2.235 2.207-2.569 3.523-2.569a4.54 4.54 0 013.081.764 2.662 2.662 0 01.447 1.99v.3a1.25 1.25 0 102.5 0v-.268a4.887 4.887 0 00-1.165-3.777C13.949.741 12.359.248 10.091.248c-3.658 0-6.023 1.989-6.023 5.069 0 2.773 1.892 4.512 4 5.927a.25.25 0 01-.139.458H1.5a1.25 1.25 0 000 2.5h10.977a.251.251 0 01.159.058 4.339 4.339 0 011.932 3.466c0 3.268-3.426 3.522-4.477 3.522-1.814 0-3.139-.405-3.834-1.173a3.394 3.394 0 01-.65-2.7 1.25 1.25 0 00-2.488-.246A5.76 5.76 0 004.4 21.753c1.2 1.324 3.114 2 5.688 2 4.174 0 6.977-2.42 6.977-6.022a6.059 6.059 0 00-.849-3.147.25.25 0 01.216-.377H22.5a1.25 1.25 0 001.25-1.255z"></path>
            </svg>
          </button>

          <button type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('underline') }"
                  @click="editor.chain().focus().toggleUnderline().run()">
            <svg viewBox="0 0 24 24"
                 id="icon--underline">
              <path d="M22.5 21.248h-21a1.25 1.25 0 000 2.5h21a1.25 1.25 0 000-2.5zM1.978 2.748h1.363a.25.25 0 01.25.25v8.523a8.409 8.409 0 0016.818 0V3a.25.25 0 01.25-.25h1.363a1.25 1.25 0 000-2.5H16.3a1.25 1.25 0 000 2.5h1.363a.25.25 0 01.25.25v8.523a5.909 5.909 0 01-11.818 0V3a.25.25 0 01.25-.25H7.7a1.25 1.25 0 100-2.5H1.978a1.25 1.25 0 000 2.5z"></path>
            </svg>
          </button>

          <button v-if="!small"
                  type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('heading', {level: 1}) }"
                  @click="editor.commands.toggleHeading({ level: 1 })">
            H1
          </button>

          <button v-if="!small"
                  type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('heading', {level: 2}) }"
                  @click="editor.commands.toggleHeading({ level: 2 })">
            H2
          </button>

          <button v-if="!small"
                  type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('heading', {level: 3}) }"
                  @click="editor.commands.toggleHeading({ level: 3 })">
            H3
          </button>

          <button v-if="!small"
                  type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('bullet_list') }"
                  @click="editor.commands.toggleBulletList()">
            <svg viewBox="0 0 24 24"
                 id="icon--ul">
              <circle cx="2.5"
                      cy="3.998"
                      r="2.5"></circle>
              <path d="M8.5 5H23a1 1 0 000-2H8.5a1 1 0 000 2z"></path>
              <circle cx="2.5"
                      cy="11.998"
                      r="2.5"></circle>
              <path d="M23 11H8.5a1 1 0 000 2H23a1 1 0 000-2z"></path>
              <circle cx="2.5"
                      cy="19.998"
                      r="2.5"></circle>
              <path d="M23 19H8.5a1 1 0 000 2H23a1 1 0 000-2z"></path>
            </svg>
          </button>

          <button v-if="!small"
                  type="button"
                  class="menubar__button"
                  :class="{ 'is-active': editor.isActive('ordered_list') }"
                  @click="editor.commands.toggleOrderedList()">
            <svg viewBox="0 0 24 24"
                 id="icon--ol">
              <path d="M7.75 4.5h15a1 1 0 000-2h-15a1 1 0 000 2zm15 6.5h-15a1 1 0 100 2h15a1 1 0 000-2zm0 8.5h-15a1 1 0 000 2h15a1 1 0 000-2zM2.212 17.248a2 2 0 00-1.933 1.484.75.75 0 101.45.386.5.5 0 11.483.63.75.75 0 100 1.5.5.5 0 11-.482.635.75.75 0 10-1.445.4 2 2 0 103.589-1.648.251.251 0 010-.278 2 2 0 00-1.662-3.111zm2.038-6.5a2 2 0 00-4 0 .75.75 0 001.5 0 .5.5 0 011 0 1.031 1.031 0 01-.227.645L.414 14.029A.75.75 0 001 15.248h2.5a.75.75 0 000-1.5h-.419a.249.249 0 01-.195-.406L3.7 12.33a2.544 2.544 0 00.55-1.582zM4 5.248h-.25A.25.25 0 013.5 5V1.623A1.377 1.377 0 002.125.248H1.5a.75.75 0 000 1.5h.25A.25.25 0 012 2v3a.25.25 0 01-.25.25H1.5a.75.75 0 000 1.5H4a.75.75 0 000-1.5z"></path>
            </svg>
          </button>

          <button type="button"
                  class="menubar__button"
                  @click="editor.commands.undo">
            <svg viewBox="0 0 24 24"
                 id="icon--undo">
              <path d="M17.786 3.77a12.542 12.542 0 00-12.965-.865.249.249 0 01-.292-.045L1.937.269A.507.507 0 001.392.16a.5.5 0 00-.308.462v6.7a.5.5 0 00.5.5h6.7a.5.5 0 00.354-.854L6.783 5.115a.253.253 0 01-.068-.228.249.249 0 01.152-.181 10 10 0 019.466 1.1 9.759 9.759 0 01.094 15.809 1.25 1.25 0 001.473 2.016 12.122 12.122 0 005.013-9.961 12.125 12.125 0 00-5.127-9.9z"></path>
            </svg>
          </button>

          <button type="button"
                  class="menubar__button"
                  @click="editor.commands.redo">
            <svg viewBox="0 0 24 24"
                 id="icon--redo">
              <path d="M22.608.161a.5.5 0 00-.545.108L19.472 2.86a.25.25 0 01-.292.045 12.537 12.537 0 00-12.966.865A12.259 12.259 0 006.1 23.632a1.25 1.25 0 001.476-2.018 9.759 9.759 0 01.091-15.809 10 10 0 019.466-1.1.25.25 0 01.084.409l-1.85 1.85a.5.5 0 00.354.853h6.7a.5.5 0 00.5-.5V.623a.5.5 0 00-.313-.462z"></path>
            </svg>
          </button>

        </div>


      <editor-content class="editor__content"
                      :style="{ 'height': contentHeight }"
                      :editor="editor" />
    </div>

  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import CharacterCount from '@tiptap/extension-character-count'


export default {
  components: {
    EditorContent,
  },
  props: {
    label: {
      type: String,
    },
    help: {
      type: String,
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: {
      type: String,
      default: "500px",
    },
    small: {
      type: Boolean,
      default: false,
    },
    characterLimit: {
        type: String,
        default: null
    }
  },
  data() {
    return {
      editor: null
    };
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  beforeMount() {

    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit,
        Underline,
        CharacterCount.configure({
          limit: this.characterLimit
        })
      ],
      onCreate: () => {
        this.editor.view.dom.setAttribute("spellcheck", "false");
        this.editor.view.dom.setAttribute("autocomplete", "off");
      },
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML())
      },

    })
  },
};
</script>

<style lang="scss" scoped>
.editor {
  .editor-label {
    margin-left: 10px;
    margin-bottom: 0;
    color: #707070;
  }

  .menubar {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #c4c4c4;
    padding-bottom: 5px;
    flex-wrap: wrap;

    .menubar__button {
      width: 35px;
      height: 35px;
      margin-right: 10px;
      padding: 5px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 15px;
        height: 15px;
      }

      font-size: 18px;

      &.is-active {
        font-weight: 700;
        border: 1px solid #c4c4c4;
        border-radius: 8px;
      }
    }
  }

  .editor-body {
    border: 1px solid #c4c4c4;
    border-radius: 20px;
    padding: 10px 20px;

    ol,
    ul {
      padding-left: 24px;
    }

    .editor__content {
      height: 500px;
      overflow-y: auto;

      ::v-deep .ProseMirror {
        height: 100%;
        padding-top: 15px;

        &.ProseMirror-focused {
          outline: none;
        }
      }
    }

    &.editor-body_disabled {
      background: #f2f2f2;
    }
  }

  &.editor_small {
    .menubar {
      .menubar__button {
        width: 25px;
        height: 25px;
        font-size: 13px;
        margin-right: 5px;

        svg {
          width: 10px;
          height: 10px;
        }
      }
    }

    .editor-body {
      .editor__content {
        font-size: 14px;
      }
    }
  }
}
</style>
